import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LabraToolTipV2 } from '@labrav/react-components'
import { isNonEmptyNumber } from '@labrav/common'

import clsx from 'clsx'
import { useFlag } from '@labrav/flags'

import { useStyles } from './ShowExpirationDateWithIcon.styles'
import { getExpirationFromDate, getFormattedLabraDate } from '../../utils/dates'

export const ShowExpirationDateWithIcon = ({
  expirePrefix = 'Expires in',
  date,
  daysToCompare = 90,
  daysLessLimit,
  shouldShowExpiringSoon = true,
  shouldShowExpired = false,
  variant = 'default',
}: {
  expirePrefix?: string
  date: string
  daysToCompare?: number
  daysLessLimit?: number
  shouldShowExpiringSoon?: boolean
  shouldShowExpired?: boolean
  variant?: 'default' | 'split'
}) => {
  const {
    isExpriringSoon,
    dayDiff,
    isOneDayLeft,
    isLessThanOneMonthLeft,
    isLessThanGivenDay,
    isExpired,
  } = getExpirationFromDate(date, daysToCompare, daysLessLimit)
  const { classes } = useStyles()
  const { flag: contractStatusUpdate } = useFlag('contractStatusUpdate')
  const isExpriringSoonCssApply = isNonEmptyNumber(daysLessLimit)
    ? isLessThanGivenDay
    : isLessThanOneMonthLeft
  const { formattedDate, formattedTime } = getFormattedLabraDate(date)

  if (isExpired && shouldShowExpiringSoon && shouldShowExpired) {
    return (
      <LabraToolTipV2 description={formattedDate} tooltipPlacement="bottom">
        <div
          className={clsx(
            classes.expirationWrapper,
            classes.expirationSoonColor
          )}
          data-testid={'expired'}
        >
          {contractStatusUpdate?.value ? (
            formattedDate
          ) : variant === 'split' ? (
            <span
              className={classes.expirePrefixSplit}
              data-testid="expired-prefix"
            >
              Expired
            </span>
          ) : (
            'Expired'
          )}
        </div>
      </LabraToolTipV2>
    )
  }

  return isExpriringSoon && shouldShowExpiringSoon ? (
    <LabraToolTipV2 description={formattedDate} tooltipPlacement="bottom">
      <div
        className={clsx(
          classes.expirationWrapper,
          isExpriringSoonCssApply ? classes.expirationSoonColor : ''
        )}
        data-testid={'expiring-soon'}
      >
        <FontAwesomeIcon
          icon={faClock}
          style={{
            width: '14px',
            height: '14px',
            marginRight: '5px',
          }}
        />
        {variant === 'split' ? (
          <>
            <span
              className={classes.expirePrefixSplit}
              data-testid="expiring-soon-prefix"
            >
              {expirePrefix}
            </span>
            <span className={classes.expireSuffixSplit}>
              {`\u00A0${dayDiff} day${isOneDayLeft ? '' : 's'}`}
            </span>
          </>
        ) : (
          `${expirePrefix} ${dayDiff} day${isOneDayLeft ? '' : 's'}`
        )}
      </div>
    </LabraToolTipV2>
  ) : (
    <div data-testid={'expiry-date'}>
      <LabraToolTipV2
        description={formattedTime}
        tooltipPlacement="bottom-start"
      >
        {formattedDate}
      </LabraToolTipV2>
    </div>
  )
}
